module.exports = __webpack_public_path__ + "img/dy-code.30c1c5a8.png";